module.exports = __webpack_public_path__ + "static/media/active_video_thumb2.38d9e5bd.png";